/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/168-meter2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zM4.732 13.034a4.501 4.501 0 00-2.688-5.762 5.953 5.953 0 011.714-3.514c1.133-1.133 2.64-1.757 4.243-1.757s3.109.624 4.243 1.757a5.958 5.958 0 011.714 3.514 4.501 4.501 0 00-2.688 5.762c-.964.629-2.09.966-3.268.966s-2.304-.338-3.268-.966zm3.889-3.018A.502.502 0 019 10.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 01-.5-.5v-1a.5.5 0 01.379-.484L7.75 3h.5l.371 7.016z"/>'
  }
})
